import cx from 'classnames'
import { TFunction } from 'i18next'
import { buttonText } from '../../../../../utils/ec-flow-texts'
import { displayS3File } from '../../../../../../../client/src/utils/s3'
import { resolveDisplayName } from '../../../../../../../server/src/utils'
import { EndUserCampaign, PartialEndUser } from '../../../../../lib/api/types'
import { endUserType } from '../../../../../utils/user-type'
import styles from './style.module.css'
import { Button } from '@alphabait/ui/components/ui/button'
import HomeHero, { homeGreetingStyle, homeHeadingStyle } from './home-hero'

type HomeProps = {
  campaign: EndUserCampaign
  endUser: PartialEndUser
  t: TFunction<'translation', undefined>
  pathname: string
  id?: string
  navigate: (path: string) => void
}

export default function ECHome(props: HomeProps) {
  if (props.campaign.customer?.endUserTheme?.heroImageUrl) {
    return <HomeHero {...props} />
  }
  return <StandardHome {...props} />
}

function StandardHome({
  campaign,
  endUser,
  id,
  t,
  pathname,
  navigate,
}: HomeProps) {
  const language = 'nl'
  const typeOfUser = endUserType(endUser.referral)
  const theme = campaign.customer?.endUserTheme

  // The theme's screen logo when it has one, else the logo this campaign uploaded.
  const logo =
    campaign.customer?.endUserTheme?.logoUrl ??
    (campaign.logo ? displayS3File(campaign.logo) : null)
  const translations =
    campaign?.ecFlowTexts?.ecFlowTexts?.[typeOfUser]?.['home']?.[language]

  const isReferral =
    endUser?.referralOf && endUser?.referralOf != endUser.campaignId

  const salutation = campaign.salutation as { salutationType?: string; nameFormat?: string } | undefined
  const formattedName = resolveDisplayName(salutation, {
    firstName: endUser.firstName || '',
    middle: endUser.middle || '',
    lastName: endUser.lastName || '',
  })
  const customSalutation =
    salutation?.salutationType && salutation?.nameFormat
      ? `${salutation.salutationType}${formattedName ? ` ${formattedName}` : ''},`
      : undefined

  const endUserSalutation =
    isReferral
      ? ''
      : campaign.postcardTemplate?.['type'] === 'flyer'
        ? `${t('ec.hello')},`
        : customSalutation || `${t('ec.dear')} ${endUser?.firstName},`
  return (
    <div
      className={cx(
        pathname.includes('campaigns')
          ? 'cursor-none pointer-events-none'
          : 'w-full',
        `grid justify-around bg-cover py-10 m-auto max-w-md w-full px-6`,
      )}
    >
      <div
        className={cx(
          styles.contentWrapper,
          'flex flex-col items-center gap-8 text-center m-auto text-inherit px-6',
        )}
      >
        {logo && <img src={logo} className="w-32" />}
        <h2 className='text-lg' style={homeGreetingStyle(theme)}>
          {endUserSalutation}
        </h2>
        {isReferral ? (
          <>
            <h1 style={homeHeadingStyle(theme)}>
              {translations?.header ?? t('ec.home.header')}
            </h1>
            <p
              className="text-xl text-slate-50"
              dangerouslySetInnerHTML={{
                __html: translations?.text ?? t('ec.home.text'),
              }}
            />
          </>
        ) : (
          <>
            <h2
              className='text-3xl font-bolder'
              style={homeHeadingStyle(theme)}
            >
              {translations?.header ?? t('ec.home.header')}
            </h2>
            <p
              className="text-xl text-slate-50"
              dangerouslySetInnerHTML={{
                __html: translations?.text ?? t('ec.home.text'),
              }}
            />
          </>
        )}
      </div>
      <div className="grid items-end my-4 m-auto max-w-md w-full pb-8 px-6">
        <Button

          size="lg"
          className="w-full rounded-lg py-4 text-base font-medium"
          onClick={() => navigate(`/${id}/choose-incentive`)}
        >
          {buttonText(campaign, 'view', t)}
        </Button>
      </div>
    </div>
  )
}
